import FormNewsletter from "@/components/FormNewsletter/form-newsletter";
import Main from "@/components/Layout/main";
import { PageContext } from "@/context/PageContext";
import { PageStoryblok } from "@/types/component-types-sb";
import React, { useContext, useEffect } from "react";
import SbEditable from "storyblok-react";
import { anyToKebab } from "@/helpers/utils";
import Components from "../components";

interface Props {
  content: PageStoryblok;
  name?: string;
}

const Page = (props: Props) => {
  const { content, name } = props;
  const { setData } = useContext(PageContext);
  const gradientFrom = content?.background_gradient_from?.color;
  const gradientTo = content?.background_gradient_to?.color;
  useEffect(() => {
    const site_background_style =
      gradientFrom && gradientTo
        ? {
            background: `linear-gradient(180deg, ${gradientFrom}, ${gradientTo})`,
          }
        : undefined;

    setData((prev: any) => ({
      ...prev,
      page_class: anyToKebab(name) || "",
      hide_site_banner: content?.hide_site_banner ?? false,
      site_background_style,
    }));
    return () =>
      setData((prev: any) => ({
        ...prev,
        page_class: "",
        hide_site_banner: false,
        site_background_style: undefined,
      }));
  }, [content?.hide_site_banner, gradientFrom, gradientTo, name, setData]);

  const body = content?.body || [];

  const mainComponents = body.filter(
    (blok) => blok.component !== "event-sticky-footer"
  );

  const stickyFooter = body.find(
    (blok) => blok.component === "event-sticky-footer"
  );

  const renderedBloks = mainComponents.map((blok) =>
    React.createElement(Components(blok.component), {
      key: blok._uid,
      blok,
    })
  );

  return (
    // @ts-expect-error
    <SbEditable content={props.content}>
      <Main className="pro-cycling-page">
        {renderedBloks}
        {!content?.hide_newsletter_sign_up_box ? <FormNewsletter /> : null}
      </Main>
      {stickyFooter &&
        React.createElement(Components(stickyFooter.component), {
          key: stickyFooter._uid,
          blok: stickyFooter,
        })}
    </SbEditable>
  );
};

export default Page;
